import React from 'react';

const responsive = (WrappedComponent) => {
  // eslint-disable-next-line react/display-name
  return class extends React.Component {
    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
      var metaTag = document.createElement('meta');
      metaTag.name = 'viewport';
      metaTag.content = 'width=device-width, initial-scale=1.0';
      document.getElementsByTagName('head')[0].appendChild(metaTag);
    }

    componentWillUnmount() {
      document.getElementsByTagName('meta')['viewport'].content = null;
    }

    render() {
      return (
        <WrappedComponent {...this.props} />
      );
    }
  };
};

export default responsive;
